<app-upsell-card
  htmlTitle="<strong>Need a</strong> Doctor's Note"
  question="Need an excuse note for work or school?"
  [slug]="slug"
>
</app-upsell-card>
